import React from "react";
import { useNavigate } from "react-router-dom"; // if using React Router
import { CheckCircle } from "lucide-react"; // optional icon library

const SuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#0f172a", // dark background like your screenshot
        color: "#a3f7bf",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <div style={{ fontSize: "80px", marginBottom: "20px" }}>
        ✅ {/* ✅Or use icon component: <CheckCircle size={80} /> */}
      </div>
      <h1 style={{ fontSize: "32px", marginBottom: "10px" }}>
        Form submitted successfully!
      </h1>
      <p
        style={{
          fontSize: "18px",
          marginBottom: "20px",
          color: "#ffffffb3",
        }}
      >
        Thank you! The form has been submitted successfully. <br />
        We will reply to you soon!
      </p>
      <button
        onClick={() =>
          (window.location.href = window.location.origin + "/threem-ui")
        }
        style={{
          backgroundColor: "#22c55e",
          color: "#fff",
          padding: "10px 20px",
          borderRadius: "8px",
          border: "none",
          cursor: "pointer",
        }}
      >
        Go back
      </button>
    </div>
  );
};

export default SuccessPage;
